import * as Yup from 'yup'

import { TFormValidator, TSanitize, TSanitizeField } from './types'

/**
 * @function sanitizeField
 * @param type
 * @param value
 */
const sanitizeField = ({ type, value }: TSanitizeField): string | null => {
  if (value) {
    switch (type) {
      case 'date':
        if (
          value.match(
            /^(19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$/,
          )
        ) {
          return value
            .split('-')
            .reverse()
            .toString()
            .replace(/\s+/g, '')
            .replace(/,/g, ' /')
        }
        return value
          .split('/')
          .reverse()
          .toString()
          .replace(/\s+/g, '')
          .replace(/,/g, '-')

      case 'number':
        return value.replace(/[^0-9]/g, '')

      default:
        return value
    }
  }

  return null
}

/**
 * @function sanitize
 * @param type
 * @param value
 */
const sanitize = ({ type, value }: TSanitize): string => {
  let parsed = value

  type.forEach(rule => {
    parsed = sanitizeField({ type: rule, value: parsed })
  })

  return parsed
}

/**
 * @function formValidator
 *
 * @param data
 * @param formRef
 * @param scheme
 */
const formValidator = async ({
  data,
  formRef,
  scheme = { sanitize: {}, validation: {} },
}: TFormValidator): Promise<any> => {
  try {
    /* eslint-disable */
    formRef?.current?.setErrors({})

    await Yup.object()
      .shape(scheme.validation)
      .validate(data, { abortEarly: false })

    if (scheme.sanitize) {
      Object.entries(scheme.sanitize).forEach(([key, rules]) => {
        const value: string = data[key as keyof typeof data]

        if (value) {
          let sanitizedValue = value
          const rule = rules.length > 1 ? (rules[0] as []) : (rules as [])
          const cb =
            rules.length > 1 && (rules[1] as (payload: string) => string)

          if (rule) {
            sanitizedValue = sanitize({
              type: rule,
              value: sanitizedValue,
            })
          }

          if (cb && sanitizedValue) {
            sanitizedValue = cb(sanitizedValue)
          }

          data = { ...data, [key]: sanitizedValue }
        }
      })
    }

    return data
  } catch (error) {
    if (error instanceof Yup.ValidationError) {
      formRef?.current?.setErrors({
        [(error.inner[0] as any).path]: error.inner[0].message,
      })
    }

    throw error
  }
}

export { formValidator, sanitize, sanitizeField }
